angular.module('impactx.user').controller('SimpleDialogCtrl', ['$scope', '$mdDialog', '$redirect', 'userData', 'TranslationService', 'buttonFunction', 'buttonTranslation', SimpleDialogCtrl]);

function SimpleDialogCtrl($scope, $mdDialog, $redirect, userData, TranslationService, buttonFunction, buttonTranslation)
{
    var self = this;

    $scope.data = userData;
    $scope.buttonTranslation = buttonTranslation;
    $scope.buttonFunction = buttonFunction;
    $scope.customerServiceTooltip = TranslationService.get("serviceUser");

    $scope.hide = function() {
        $mdDialog.hide();
    };

    $scope.callButtonFunctionAndHide = function(event) {
        $mdDialog.hide();
        buttonFunction({event: event});
    };
}